import { Box, Button } from '@mui/material';
import { brandColors } from 'types/colors';

const FILTERS = [
  { key: 'ALL', label: 'All' },
  { key: 'ACTIVE', label: 'Active' },
  { key: 'INACTIVE', label: 'Inactive' },
  { key: 'RECOMMENDATIONS', label: 'Recommendations (generated)' },
  { key: 'MANUAL', label: 'Manually created schedules' },
  { key: 'GLOBAL', label: 'Global schedules' },
  { key: 'SPECIFIC', label: 'Specific controller schedules' },
];

export const SchedulesFilterBar = ({ selectedFilters, onChange }) => {
  const handleToggle = key => {
    if (key === 'ALL') {
      onChange(['ALL']);
      return;
    }

    const withoutAll = selectedFilters.filter(filterKey => filterKey !== 'ALL');
    const next = selectedFilters.includes(key)
      ? withoutAll.filter(filterKey => filterKey !== key)
      : [...withoutAll, key];

    onChange(next.length === 0 ? ['ALL'] : next);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ml: 1, mb: 2 }}>
      {FILTERS.map(filter => {
        const isSelected = selectedFilters.includes(filter.key);
        return (
          <Button
            key={filter.key}
            variant="inherit"
            disableElevation
            disableRipple
            disableFocusRipple
            onClick={() => handleToggle(filter.key)}
            aria-pressed={isSelected}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              backgroundColor: isSelected ? brandColors.BLUE : brandColors.BLUE_LIGHT,
              color: isSelected ? '#fff' : brandColors.BLUE,
              minHeight: 32,
              px: 2,
              '&:hover': {
                backgroundColor: isSelected ? brandColors.BLUE : brandColors.BLUE_LIGHT,
                opacity: 0.9,
              },
              '&:active': {
                backgroundColor: isSelected ? brandColors.BLUE : brandColors.BLUE_LIGHT,
              },
              '&.Mui-focusVisible': {
                boxShadow: 'none',
              },
            }}>
            {filter.label}
          </Button>
        );
      })}
    </Box>
  );
};
